// eslint-disable-next-line import/prefer-default-export
export function getImageFilePreview(file, maxWidth = 400, maxHeight = 225) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = e => resolve(e);
    reader.readAsDataURL(file);
  })
    .then(fileReadedEvent =>
      (new Promise((resolve) => {
        const img = document.createElement('img');
        img.onload = event => resolve({ event, img });
        img.src = fileReadedEvent.target.result;
      })),
    )
    .then(({ img }) => {
      const canvas = document.createElement('canvas');

      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      return canvas.toDataURL(file.type);
    });
}



// WEBPACK FOOTER //
// ./src/services/ImagePreview.js